class BmUIKitConfig {
    static setOptions(options) {
        Object.entries(options).forEach(([key, value])=>{
            BmUIKitConfig.config[key] = value;
        });
    }
    static getOptions() {
        return BmUIKitConfig.config;
    }
    static getOption(key) {
        return BmUIKitConfig.config[key];
    }
    static setOption(key, value) {
        BmUIKitConfig.config[key] = value;
        return this;
    }
}
BmUIKitConfig.config = {
    enviroment: "prod",
    customLinkProvider: (props)=>props,
    __: (key)=>key
};

export { BmUIKitConfig };
//# sourceMappingURL=config.js.map
